/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/compiled/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex } from '@atlaskit/primitives/compiled/flex';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives/compiled/stack';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/compiled/text';
import { components } from '@atlaskit/react-select/components';
import { token } from '@atlaskit/tokens';

import { BoldMatchingText } from './bold-matching-text';
import type { CustomSelectOptionProps } from './types';

const styles = cssMap({
	customSelectOptionWrapper: {
		paddingInline: token('space.200'),
		paddingBlock: token('space.100'),
	},
	iconBoxStyle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: token('space.150'),
		flexShrink: 0,
	},
	contentBoxStyle: {
		fontWeight: token('font.weight.regular'),
	},
});

export const CustomSelectOption: <isMulti extends boolean = false>(
	props: CustomSelectOptionProps<isMulti>,
) => JSX.Element = <isMulti extends boolean = false>(props: CustomSelectOptionProps<isMulti>) => {
	const { data, selectProps } = props;
	const { Option } = components;

	const { inputValue } = selectProps;

	const hasAvatarOrByline = data?.avatar || data?.byline;
	const displayText = (data?.displayLabel ?? data?.label) as string;

	return (
		<Option {...props}>
			<Box xcss={hasAvatarOrByline ? styles.customSelectOptionWrapper : undefined}>
				<Flex alignItems="center">
					{data?.avatar && (
						<Box xcss={styles.iconBoxStyle} testId="custom-select-option-avatar">
							{data.avatar}
						</Box>
					)}
					{displayText && (
						<Box xcss={styles.contentBoxStyle} testId="custom-select-option-label">
							<Stack space="space.025">
								<Text>
									<BoldMatchingText match={inputValue ?? ''}>{displayText}</BoldMatchingText>
								</Text>
								{data.byline && (
									<Text size="small" testId="custom-select-option-byline">
										<BoldMatchingText match={inputValue ?? ''} isSmall>
											{data.byline}
										</BoldMatchingText>
									</Text>
								)}
							</Stack>
						</Box>
					)}
				</Flex>
			</Box>
		</Option>
	);
};
